// CSS Modules - component class name prefix: ContactList__

<template>
  <div class="ContentTabs__container">
    <div v-if="!isMobile" class="ContentTabs__tabs">
      <a
        v-for="(tab, index) in config.length"
        :key="`${index}-aKey`"
        v-on:click="updateTabs(tab)"
        :class="[
          'ContentTabs__tab',
          { ContentTabs__active: activeTab === tab },
          { ContentTabs__disabled: config[index].disabled }
        ]"
      >
        {{ config[index].title }}
      </a>
      <div
        :class="[
          'ContentTabs__content',
          { ContentTabs__activeContent: activeTab === tab }
        ]"
        v-for="(tab, index) in config.length"
        :key="`${index}-bKey`"
      >
        <ContactListEntries
          v-if="activeTab === tab"
          :config="config[index]"
          :state="computedState"
          :worldwideConfig="worldwideConfig"
          :tab="tab"
          ref="contactListDesktop"
        />
      </div>
    </div>
    <div v-if="isMobile" class="ContentTabs__tabs ContentTabs__mobile">
      <div v-for="(tab, index) in config.length" :key="`${index}-cKey`">
        <a
          v-if="!config[index].disabled"
          v-on:click="updateTabs(tab)"
          :class="[
            'ContentTabs__tab',
            { ContentTabs__active: activeTab === tab && mobileHidden !== tab }
          ]"
        >
          {{ config[index].title }}
        </a>
        <div
          :class="[
            'ContentTabs__content',
            { ContentTabs__activeContent: activeTab === tab && !isMobile },
            {
              ContentTabs__activeContent:
                activeTab === tab && isMobile && mobileHidden !== tab
            }
          ]"
        >
          <ContactListEntries
            v-if="activeTab === tab"
            :config="config[index]"
            :state="computedState"
            :worldwideConfig="worldwideConfig"
            :tab="tab"
            ref="contactListMobile"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactListEntries from "./ContactListEntries";

export default {
  name: "ContactList",
  components: {
    ContactListEntries
  },
  props: {
    config: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      zipValue: null,
      isMobile: false,
      activeTab: null,
      mobileHidden: null,
      content: null,
      data: {},
      contentLoaded: false,
      activeTabPreselected: false,
      filter: {
        colour: "blue",
        initialSelectOption: ""
      },
      selectOptions: [],
      selectOptionsIds: [],
      queryStringValue: null,
      queryStringValueTwo: null,
      worldwideConfig: {}
    };
  },
  computed: {
    computedState() {
      return {
        contentLoaded: this.contentLoaded,
        isMobile: this.isMobile,
        activeTab: this.activeTab,
        mobileHidden: this.mobileHidden,
        content: this.content,
        zipValue: this.zipValue,
        data: this.data,
        filter: this.filter,
        selectOptions: this.selectOptions
      };
    }
  },
  methods: {
    checkScreenSize() {
      window.innerWidth < 780
        ? (this.isMobile = true)
        : (this.isMobile = false);
    },
    initTabs() {
      const queries = window.location.search.substring(1).split("&");
      let queryStringTabId = null;
      if (queries) {
        for (const query of queries) {
          if (query.includes("tab")) {
            queryStringTabId = query.split("=")[1];
          }
          if (query.includes("cnEntry")) {
            this.queryStringValue = decodeURI(query.split("=")[1]);
          }
          if (query.includes("country")) {
            this.queryStringValueTwo = decodeURI(query.split("=")[1]);
          }
        }
      }
      if (queryStringTabId) {
        for (const [index, tab] of this.config.entries()) {
          if (
            tab.id &&
            !tab.worldwide &&
            queryStringTabId === tab.id &&
            !tab.disabled
          ) {
            this.activeTab = index + 1;
            this.activeTabPreselected = true;
            this.getContentFromId(tab.id);
          } else if (
            tab.id &&
            tab.worldwide &&
            queryStringTabId === tab.id &&
            this.queryStringValueTwo &&
            !tab.disabled
          ) {
            this.worldwideConfig = {
              ...tab.config,
              currentRegion: this.queryStringValue,
              currentCountry: this.queryStringValueTwo
            };
            this.activeTab = index + 1;
            this.activeTabPreselected = true;
            this.content = null;
            this.contentLoaded = true;
            this.queryStringValue = null;
          }
        }
      } else {
        for (const [index, tab] of this.config.entries()) {
          if (tab.active && !tab.disabled) {
            this.activeTab = index + 1;
            this.activeTabPreselected = true;
            if (tab.id && !tab.worldwide) {
              if (tab.initialSelectOption) {
                this.filter.initialSelectOption = tab.initialSelectOption;
              }
              this.getContentFromId(tab.id);
            } else if (tab.worldwide) {
              this.worldwideConfig = tab.config;
              this.content = null;
              this.contentLoaded = true;
            }
          }
        }
      }
      if (!this.activeTabPreselected) {
        this.activeTab = 1;
        if (this.config[0].id && !this.config[0].worldwide) {
          if (this.config[0].initialSelectOption) {
            this.filter.initialSelectOption = this.config[0].initialSelectOption;
          }
          this.getContentFromId(this.config[0].id);
        } else if (this.config[0].worldwide) {
          this.worldwideConfig = this.config[0].config;
          this.content = null;
          this.contentLoaded = true;
        }
      }
    },
    updateTabs(tab) {
      this.$refs = {};
      const elm = event.currentTarget;
      if (!elm.classList.contains("ContentTabs__disabled")) {
        this.contentLoaded = false;
        if (this.config[tab - 1].initialSelectOption) {
          this.selectOptions = [];
          this.filter.initialSelectOption = this.config[
            tab - 1
          ].initialSelectOption;
        }
        if (this.config[tab - 1].id && !this.config[tab - 1].worldwide) {
          this.getContentFromId(this.config[tab - 1].id);
        } else if (this.config[tab - 1].worldwide) {
          this.worldwideConfig = this.config[tab - 1].config;
          this.content = null;
          this.contentLoaded = true;
        } else {
          this.content = null;
        }
        if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab !== this.mobileHidden
        ) {
          this.mobileHidden = tab;
        } else if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab === this.mobileHidden
        ) {
          this.mobileHidden = null;
        } else if (this.isMobile && this.activeTab !== tab) {
          this.mobileHidden = null;
          this.activeTab = tab;
        } else {
          this.activeTab = tab;
        }
      }
    },
    getContentFromId(id) {
      const elm = document.getElementById(id);
      this.data = JSON.parse(elm.dataset.config);

      if (this.data.contact) {
        this.content = this.data.contact.contacts;
        this.contentLoaded = true;
      } else if (this.data.group) {
        for (const group of this.data.group.groups) {
          this.selectOptions.push(group.name);
          if (this.queryStringValue) {
            this.selectOptionsIds.push(group.id.toString());
          }
        }
        this.content = this.data.group.groups;
        if (this.queryStringValue) {
          const nameIndex = this.selectOptionsIds.indexOf(
            this.queryStringValue
          );
          if (nameIndex !== -1) {
            this.filter.initialSelectOption = this.selectOptions[nameIndex];
          } else {
            this.filter.initialSelectOption = this.selectOptions[0];
          }
          this.contentLoaded = true;
          setTimeout(() => {
            this.$refs.contactListDesktop.updateFilter(
              this.filter.initialSelectOption
            );
            this.$refs.contactListMobile.updateFilter(
              this.filter.initialSelectOption
            );
          }, 500);
        } else {
          this.contentLoaded = true;
        }
      } else if (this.data.zip) {
        this.content = this.data.zip.ranges;
        if (this.queryStringValue) {
          this.zipValue = this.queryStringValue;
        }
        this.contentLoaded = true;
      } else {
        this.content = null;
        this.contentLoaded = false;
      }
      this.queryStringValue = null;
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
    this.checkScreenSize();
    this.initTabs();
  },
  destroyed() {
    window.removeEventListener("resize", this.checkScreenSize);
  }
};
</script>

<style module lang="scss">
@import "./ContactList.scss";
</style>
